import type { ReactNode } from 'react';

export function highlight(text: string, query: string): ReactNode {
  if (!query) return text;
  const q = query.trim();
  if (!q) return text;
  const tokens = q.split(/\s+/).filter(Boolean).map(escapeRe);
  if (!tokens.length) return text;
  const re = new RegExp(`(${tokens.join('|')})`, 'gi');
  const parts = text.split(re);
  return parts.map((p, i) =>
    re.test(p)
      ? <mark key={i} className="ss-mark">{p}</mark>
      : <span key={i}>{p}</span>,
  );
}

function escapeRe(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
